import { useMemo } from "react";
import { useSponsorshipTerms } from "@/features/sponsorship/hooks/useSponsorshipTerms";
import { deriveBareme } from "@/features/sponsorship/utils/deriveBareme";
import type { SponsorshipBareme } from "@/features/sponsorship/utils/deriveBareme";

// Barème vivant : dérivé du règlement publié (base) via useSponsorshipTerms,
// avec repli sur les constantes par défaut quand rien n'est publié.
export const useSponsorshipBareme = (): SponsorshipBareme => {
  const { term } = useSponsorshipTerms();

  return useMemo(() => deriveBareme(term), [term]);
};
